try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('@popperjs/core');
    window.bootstrap = require('bootstrap');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
} catch (exception) {
    console.error(exception);
}

require('select2');
require('jquery-validation');
require('apexcharts');
require('jquery-multifile');
require('bootstrap-fileinput');
require('perfect-scrollbar');
require('type-ahead');
require('moment-timezone');
require('daterangepicker');
require('datatables.net');
require('datatables.net-bs5');
require('datatables.net-responsive');
require('datatables.net-responsive-bs5');
require("intl-tel-input/build/js/intlTelInput-jquery");
require('bootstrap-input-spinner');
require('jquery.steps');
require('wow.js');

window.Swal = require('sweetalert2');
window.moment = require('moment');
window.SimpleBar = require('simplebar').default

window.feather = require('feather-icons');

window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

window.Pusher = require('pusher-js');
import Echo from 'laravel-echo';
import { createApp } from 'vue';
import MessageCounter from './components/counters/messages';
import NotificationCounter from './components/counters/notifications';
import Conversations from './components/messages/Conversations';

if (document.querySelector("meta[name='user_id']")) {
    // Live updates are optional, the rest of the bundle is not: without a
    // broadcast key Pusher throws on construction, and that throw used to
    // abort everything scripts.js loads after this file - the delete
    // confirmations, form validation and select2 among them.
    try {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.MIX_PUSHER_APP_KEY,
            cluster: process.env.MIX_PUSHER_APP_CLUSTER,
            forceTLS: true
        });

        window.Echo.join('online')
            .joining((user) => {
                axios.put('/user/' + user.id + '/online', {});
            });
    } catch (exception) {
        console.error(exception);
    }

    const app = createApp({
        components: {
            MessageCounter,
            NotificationCounter,
            Conversations
        }
    });

    // Vue rethrows out of mount() when no handler is set, so one component
    // failing would abort the bundle the same way the Echo throw did.
    app.config.errorHandler = (exception) => {
        console.error(exception);
    };

    window.app = app.mount('#app')
}
